module.exports = __webpack_public_path__ + "img/AP.3976ce7c.png";